import { Serializable } from './commom/serializable';
import { RecebeLote } from './recebe-lote';
import { DefeitoGrupo } from './defeito-grupo';
import { DefeitoTipo } from './defeito-tipo';
import { Usuario } from './usuario';

export class DefeitoLote implements Serializable<DefeitoLote> {
    public Id: number;
    public RecebeLote: RecebeLote;
    public Qtde: number;
    public DefeitoGrupo: DefeitoGrupo;
    public DefeitoTipo: DefeitoTipo;
    public Tipo: string; 
    public Usuario: Usuario; 
    

    deserialize(input: Object): DefeitoLote {
        Object.assign(this, input);

        return this;
    }

}


// WEBPACK FOOTER //
// ./src/entities/defeito-lote.ts